import { isPositiveNumber, reduce } from "et3-type-guards";

import { DEFAULT_TIME } from "../../../../../../constants/input-entries-constants";

import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";

import getKhattabat102Store from "../../../../../../stores/khattabat-stores/102-stores";

import { TKhattabatMessage } from "../../../../../../Types";

import Message from "./message";
import OneOTwoMessageHiddenIndicator from "./message/OneOTwoMessageHiddenIndicator";
import OneOTwoMessageReactionBar from "./message/OneOTwoMessageReactionBar";

const UserMessageRow = withLiteObserverAndTheme<{
  khattabatMessage: TKhattabatMessage;
  isLastInSubGroup: boolean;
  conversationID: string;
  isOneOTwoConversation: boolean;
}>((props) => {
  const {
    khattabatMessage,
    isLastInSubGroup,
    conversationID,
    isOneOTwoConversation
  } = props;

  const isKhattabaMessage = isPositiveNumber(
    khattabatMessage.isKhattabaMessage
  );
  const isClientMessage = isPositiveNumber(khattabatMessage.isClientMessage);
  const reducedMessage = reduce(() => khattabatMessage.message, "");
  const reducedMessageType = reduce(
    () => khattabatMessage.messageType,
    "text"
  );
  const reducedCreatedOn = reduce(
    () => khattabatMessage.createdOn,
    DEFAULT_TIME
  );
  const isSeenMessage = isPositiveNumber(khattabatMessage.isSeen);
  const reducedGender = reduce(() => khattabatMessage.senderGender, "m");

  const khattabat102Store = getKhattabat102Store(conversationID);
  const messageId = khattabat102Store.getOneOTwoMessageId(khattabatMessage);
  const isOneOTwoMessage = isOneOTwoConversation && isPositiveNumber(messageId);

  const hasReactionHistory = isOneOTwoMessage
    ? khattabat102Store.getHasMessageReactionHistory(messageId)
    : false;
  const shouldRenderReactionBar = isOneOTwoMessage
    ? khattabat102Store.getShouldRenderMessageReactionBar(messageId)
    : false;
  const hasActiveHiddenAction = isOneOTwoMessage
    ? khattabat102Store.getHasActiveMessageHiddenAction(messageId)
    : false;

  return (
    <>
      <Message
        isKhattabaMessage={isKhattabaMessage}
        isLastInSubGroup={isLastInSubGroup}
        isClientMessage={isClientMessage}
        message={reducedMessage}
        messageType={reducedMessageType}
        createdOn={reducedCreatedOn}
        isSeen={isSeenMessage}
        senderGender={reducedGender}
        reactionsSlot={
          shouldRenderReactionBar ? (
            <OneOTwoMessageReactionBar
              conversationID={conversationID}
              messageId={messageId}
              hasReactionHistory={hasReactionHistory}
              isKhattabaMessage={isKhattabaMessage}
              senderGender={reducedGender}
            />
          ) : null
        }
        hiddenIndicatorSlot={
          hasActiveHiddenAction ? (
            <OneOTwoMessageHiddenIndicator
              conversationID={conversationID}
              messageId={messageId}
            />
          ) : null
        }
      />
      <Et3Margin top={2} bottom={2} left={0} right={0} />
    </>
  );
});

export default UserMessageRow;
